import { Box, List } from '@material-ui/core'
//@ts-ignore
import { useTheme } from 'styled-components'
import { observer } from 'mobx-react'
import { AccountSettingsGroupItemName } from 'models/account-settings/account-settings.store'
import AccountSettingsItem from './AccountSettingsItem'

import { StyledEditIcon, StyledFilterIcon, StyledSecurityIcon } from './styled'
import { useHistory } from 'react-router-dom'
import { BackendUser } from 'common/types'
import { PropsWithChildren } from 'react'
import { DEV_ONLY } from 'common/globalConstants'

interface IAccountSettingsDrawer {
  backendUser: BackendUser
}

export const AccountSettingsDrawer = ({backendUser}: PropsWithChildren<IAccountSettingsDrawer>) => {
  const theme = useTheme()
  const history = useHistory()
  

  return (
    <Box display="flex" color={theme.colors.accent1} bgcolor={theme.colors.backgroundII}>
      <List component="nav" style={{ marginBottom: '100px' }}>
        {DEV_ONLY && (
          <AccountSettingsItem
            groupName={AccountSettingsGroupItemName.EDIT_PROFILE}
            onListItemClick={() => history.push('/edit-profile')}
            icon={<StyledEditIcon />}
          />
        )}
        <AccountSettingsItem
          groupName={AccountSettingsGroupItemName.NOTIFICATIONS}
          onListItemClick={() => history.push('/edit-notifications')}
          icon={<StyledFilterIcon />}
        />
        {DEV_ONLY && backendUser?.authType === 'creds' &&(<AccountSettingsItem
          groupName={AccountSettingsGroupItemName.SECURITY}
          onListItemClick={() => history.push('/edit-mobile')}
          icon={<StyledSecurityIcon />}
        />)}
      </List>
    </Box>
  )
}

export default observer(AccountSettingsDrawer)
